<script>
  import { onMount, getContext } from 'svelte';

  import EmojiPicker from '@app-components/EmojiPicker.svelte';

  import Text from '@components/Text.svelte';

  import { getProfileStore } from '@stores/profile';
  import { getCurrentUserStore } from '@stores/current_user';

  import GroupCollectionAjax from '@ajax/group_collection';
  import BrowserUtils from '@utils/browser-utils';
  import ComponentEvents from '@utils/component-events';
  import BootstrapDropdown from '@utils/bootstrap-dropdown';
  import { page } from '$app/stores';
  import CustomScroll from '@utils/custom-scroll';

  export let user;
  export let id;
  export let mobile = false;
  export let groupSorting = false;
  import jQuery from 'jquery';
  let groupsStore = getProfileStore('groupsStore');
  let groupCollectionStore = getProfileStore('groupCollectionStore');
  let editable = user.permissions.edit;
  let allProfileGroupsLoaded = getContext('allProfileGroupsLoaded');
  let collection = groupCollectionStore.find(id);
  let currentUser = getCurrentUserStore('default');

  let showEmoji = false;

  let openEmojiSelector = function () {
    if (editable && !mobile) {
      showEmoji = true;
    }
  };

  let closeEmojiSelector = function () {
    showEmoji = false;
  };

  let selectEmoji = async function (emoji) {
    await updateCollection({ emoji_id: emoji.id });
  };

  let updateCollection = async function (data) {
    let resp = await GroupCollectionAjax.update(collection, data);
    collection.set(resp);
  };

  let removeCollectionAction = function () {
    jQuery(`[data-group-collection-id="${id}"]`).parent().find('.remove-btn').click();
  };

  onMount(() => {
    let unsubCollection = collection.subscribe((x) => (collection = x));
    let unsubGroups = groupsStore.subscribe((x) => (groupsStore = x));
    return () => {
      unsubGroups();
      unsubCollection();
    };
  });
</script>

<style style="text/scss" lang="scss">
  @import '../../../vendor/design-system.scss';

  .profile-sections-content-item {
    height: 48px;
    font-size: 14px;
    font-weight: bold;
    box-shadow: 0 6px 32px -10px rgba(0, 0, 0, 0.25);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    background-color: white;
    padding-left: 24px;
    padding-right: 20px;
  }

  .profile-sections-content-item-removable {
    &:hover {
      .options-button {
        display: block;
      }

      .group-items {
        display: none;
      }
    }
  }

  .right-side-tile {
    font-size: 12px;
    color: #808080;
    font-weight: 300;
    display: flex;
    justify-content: flex-end;

    .options-button {
      display: none;
      width: 21px;
      margin-right: -6px;
      margin-top: 3px;
      margin-left: -8px;

      path {
        fill: rgb(213, 207, 234);
      }

      &:hover {
        path {
          fill: #a893f9 !important;
        }
      }
    }
  }

  .editable.emoji {
    cursor: pointer;

    &:hover {
      margin: -5px;
      padding: 5px;
      border-radius: 8px;
      background: #ede9ff;
    }
  }

  * :global(.emoji-picker) {
    z-index: 1;
  }

  .dropdown-menu {
    box-shadow: 0 3px 15px rgba(0, 0, 0, 0.09);
    border: 1px solid #ececec;
    border-radius: 10px;
    margin-left: -140px !important;

    a {
      font-size: 15px;
      opacity: 0.5;
      color: black;
      &:hover {
        opacity: 1;
      }
    }
  }

  .delete-btn {
    color: #ff5567 !important;
    opacity: 1 !important;
    display: flex;
    align-items: center;
    font-weight: 500;

    &:hover {
      color: #99333d !important;
      background-color: white;
    }

    img {
      margin-right: 10px;
      transform: scale(0.7);
    }

    span {
      margin-top: 1px;
    }
  }

  .share-btn {
    color: $neutral-black !important;
    opacity: 1 !important;
    display: flex;
    align-items: center;
    font-weight: 500;
    background-color: white;

    &:hover {
      color: $purple-hover !important;
    }

    img {
      margin-right: 10px;
      transform: scale(0.7);
    }

    span {
      margin-top: 1px;
    }
  }
</style>

<div
  class="profile-sections-content-item"
  class:profile-sections-content-item-removable={user.permissions.edit && !groupSorting && !mobile}
  on:click={async (e) => {
    if (
      !user.permissions.edit ||
      jQuery(e.target).hasClass('profile-sections-content-item') ||
      jQuery(e.target).hasClass('uneditable-content')
    ) {
      await BrowserUtils.goToElementWithScroll(jQuery(`[data-group-collection-id="${id}"]`)[0], { offsetTop: -100 });

      ComponentEvents.trigger('profile-sticky-nav-show-sticky', {
        showStickyNav: false,
      });
    }
  }}>
  <div>
    {#if editable && showEmoji}
      <div class="backdrop" style="z-index: 1" on:click|preventDefault|stopPropagation={closeEmojiSelector} />

      <div class="emoji-container">
        <EmojiPicker
          mobile={mobile}
          on:emoji-selected={(e) => {
            closeEmojiSelector();
            selectEmoji(e.detail.emoji);
          }} />
      </div>
    {/if}

    <div
      class="emoji"
      class:editable={editable && !mobile}
      on:click={(e) => {
        if (user.permissions.edit) {
          e.stopPropagation();
          e.preventDefault();
          openEmojiSelector();
        }
      }}>
      <div class="icon">
        <img height="24" width="24" src={collection.emoji.outside_src} alt="{collection.emoji.name} Emoji" />
      </div>
    </div>
  </div>
  <div style="flex: 1; margin: 0 12px;" class="editable-content">
    <Text
      lines={1}
      text={collection.name}
      expand={false}
      editable={false}
      value={collection.name}
      style="line-height: 20px; font-size: 14px; font-weight: 500; padding: 2px;
      padding-left: 6px; padding-right: 6px; margin: -2px; margin-left: -6px; outline: none; width: inherit; max-height: 48px; display: -webkit-box !important; {mobile
        ? 'word-break: break-all;'
        : ''}"
      on:input={(e) => (collection.name = e.detail.text)}
      on:blur={(e) => {
        updateCollection({ name: e.detail.text });
      }} />
  </div>
  <div class="right-side-tile">
    <div style="cursor: default;" class="group-items">
      {#if $allProfileGroupsLoaded}
        {groupsStore.findByIds(collection.group_base_sort_order).length}
      {/if}
    </div>
    {#if !mobile}
      <div class="options-button">
        <div class="dropdown" use:BootstrapDropdown.setup>
          <span data-bs-toggle="dropdown">
            <svg
              style="transform: rotate(90deg);"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="svelte-3ziclj">
              <mask id={id} mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
                <rect width="20" height="20" fill="white" />
              </mask>
              <g mask="url(#{id})">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M2.5 12.5C1.11929 12.5 -4.89256e-08 11.3807 -1.09278e-07 10C-1.69631e-07 8.61929 1.11929 7.5 2.5 7.5C3.88071 7.5 5 8.61929 5 10C5 11.3807 3.88071 12.5 2.5 12.5ZM17.5 12.5C16.1193 12.5 15 11.3807 15 10C15 8.61929 16.1193 7.5 17.5 7.5C18.8807 7.5 20 8.61929 20 10C20 11.3807 18.8807 12.5 17.5 12.5ZM7.5 10C7.5 11.3807 8.61929 12.5 10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10Z"
                  fill="#EAE4FF"
                  class="svelte-3ziclj" />
              </g>
            </svg>
          </span>
          <ul class="dropdown-menu">
            <li>
              <a
                href=""
                class="share-btn"
                on:click|preventDefault|stopPropagation={() => {
                  CustomScroll.copyCollectionLink($page, id, currentUser, user.id);
                }}>
                <img src="/images/options-menu/share.svg" />
                <span>Share</span>
              </a>
            </li>
            <li>
              <a href="" class="delete-btn" on:click|preventDefault|stopPropagation={removeCollectionAction}>
                <img src="/images/options-menu/delete.svg" />
                <span>Delete</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    {/if}
  </div>
</div>
